import { render, staticRenderFns } from "./languageChange.vue?vue&type=template&id=f920ade8&scoped=true&"
import script from "./languageChange.vue?vue&type=script&lang=js&"
export * from "./languageChange.vue?vue&type=script&lang=js&"
import style0 from "./languageChange.vue?vue&type=style&index=0&id=f920ade8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f920ade8",
  null
  
)

export default component.exports